import { frontendURL } from '../../../../helper/URLHelper';

const conversations = (
  accountId,
  claudiaOnly = false,
  { hasClaudiaInboxes = false, parallelConversationsEnabled = false } = {}
) => {
  const menuItems = [
    {
      icon: 'chat',
      label: 'ALL_CONVERSATIONS',
      key: 'conversations',
      toState: frontendURL(`accounts/${accountId}/dashboard`),
      toolTip: 'Conversation from all subscribed inboxes',
      toStateName: 'home',
    },
    // Audit entry point: the conversation list already scoped to what can be
    // audited (resolved + last 7 days + ClaudIA inboxes), reproducing the old
    // Hub's default audit filter. Role gating rides on the route's own
    // permissions (administrator + cx_engineer), which Secondary.vue applies.
    {
      // The magnifier is the audit metaphor in the product (it is the glyph on
      // the per-message audit trigger). NOT `search-check`: that one is a
      // multi-path stroke icon, and SecondaryNavItem renders every icon with
      // the fill renderer (it does not forward `iconLib`), which turns it into
      // a blob.
      icon: 'search',
      label: 'CLAUDIA_AUDIT_CONVERSATIONS',
      key: 'conversation_audit',
      toState: frontendURL(`accounts/${accountId}/audit/conversations`),
      toStateName: 'conversation_audit',
    },
    {
      icon: 'mention',
      label: 'MENTIONED_CONVERSATIONS',
      key: 'conversation_mentions',
      toState: frontendURL(`accounts/${accountId}/mentions/conversations`),
      toStateName: 'conversation_mentions',
    },
    {
      icon: 'mail-unread',
      label: 'UNATTENDED_CONVERSATIONS',
      key: 'conversation_unattended',
      toState: frontendURL(`accounts/${accountId}/unattended/conversations`),
      toStateName: 'conversation_unattended',
    },
    {
      icon: 'chat-multiple',
      label: 'PARALLEL_CONVERSATIONS',
      key: 'conversation_parallel',
      toState: frontendURL(`accounts/${accountId}/parallel/conversations`),
      toStateName: 'conversation_parallel',
    },
  ];

  const claudiaOnlyHiddenItems = new Set([
    'conversation_mentions',
    'conversation_unattended',
  ]);
  const visibleItems = menuItems.filter(item => {
    // Nothing to audit without a ClaudIA inbox: the view would come up empty
    // by construction (its preset is scoped to those inboxes).
    if (item.key === 'conversation_audit') return hasClaudiaInboxes;
    // Per-account feature flag gate — the routes stay registered so a child
    // opened while the flag was on remains reachable by direct URL.
    if (item.key === 'conversation_parallel') {
      return parallelConversationsEnabled;
    }
    return !claudiaOnly || !claudiaOnlyHiddenItems.has(item.key);
  });

  return {
    parentNav: 'conversations',
    routes: [
      'home',
      'inbox_dashboard',
      'inbox_conversation',
      'conversation_through_inbox',
      'notifications_dashboard',
      'label_conversations',
      'conversations_through_label',
      'team_conversations',
      'conversations_through_team',
      'conversation_mentions',
      'conversation_through_mentions',
      'conversation_participating',
      'conversation_through_participating',
      'folder_conversations',
      'conversations_through_folders',
      'conversation_unattended',
      'conversation_through_unattended',
      'conversation_parallel',
      'conversation_through_parallel',
      'conversation_audit',
    ],
    menuItems: visibleItems,
  };
};

export default conversations;
